import React from 'react';
import PropTypes from 'prop-types';
export default function IconUnduh({ className }){
  return(
    <svg className={className} fill="none" height="18" viewBox="0 0 18 18" width="18" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.5 8.99998C16.5 13.1431 13.1431 16.5 9 16.5C4.85685 16.5 1.5 13.1431 1.5 8.99998C1.5 4.85685 4.85685 1.5 9 1.5C13.1431 1.5 16.5 4.85685 16.5 8.99998ZM12.1573 8.12599L9.96774 10.4093V4.88709C9.96774 4.48487 9.64415 4.16128 9.24194 4.16128H8.75806C8.35585 4.16128 8.03226 4.48487 8.03226 4.88709V10.4093L5.84274 8.12599C5.56149 7.83265 5.09274 7.8266 4.80544 8.1139L4.47581 8.44656C4.19153 8.73083 4.19153 9.19051 4.47581 9.47176L8.48589 13.4849C8.77016 13.7691 9.22984 13.7691 9.51109 13.4849L13.5242 9.47176C13.8085 9.18748 13.8085 8.72781 13.5242 8.44656L13.1946 8.1139C12.9073 7.8266 12.4385 7.83265 12.1573 8.12599Z" fill="white"/>
    </svg>
  );
}
IconUnduh.propTypes = {
  className: PropTypes.string
};
